import { apiFetch } from "./client";

export interface App {
  appId: string;
  name: string;
  description?: string;
  ownerEmail: string;
  createdAt: string;
  updatedAt: string;
}

export interface ApiKey {
  appId: string;
  keyId: string;
  lastFour: string;
  label?: string;
  createdAt: string;
  revokedAt: string | null;
}

export interface IssuedKey {
  keyId: string;
  lastFour: string;
  label?: string;
  plaintext: string;
}

export const appsApi = {
  list: () => apiFetch<{ apps: App[] }>("/apps"),
  get: (appId: string) => apiFetch<{ app: App; apiKeys: ApiKey[] }>(`/apps/${appId}`),
  create: (data: { name: string; description?: string; ownerEmail: string }) =>
    apiFetch<App>("/apps", { method: "POST", body: JSON.stringify(data) }),
  update: (appId: string, data: Partial<Omit<App, "appId" | "createdAt" | "updatedAt">>) =>
    apiFetch<App>(`/apps/${appId}`, { method: "PATCH", body: JSON.stringify(data) }),
  remove: (appId: string) => apiFetch<void>(`/apps/${appId}`, { method: "DELETE" }),
  issueKey: (appId: string, label?: string) =>
    apiFetch<IssuedKey>(`/apps/${appId}/keys`, {
      method: "POST",
      body: JSON.stringify({ label }),
    }),
  revokeKey: (appId: string, keyId: string) =>
    apiFetch<void>(`/apps/${appId}/keys/${keyId}`, { method: "DELETE" }),
};
